import React from 'react'
import { LEGAL_URLS } from '@educator/constants/legalUrls'
import { Trans } from '@mc/i18n'

const links = {
  termsLink: LEGAL_URLS.termsOfService,
  aiTermsLink: LEGAL_URLS.aiTerms,
  privacyLink: LEGAL_URLS.privacyPolicy,
  speechToTextLink: LEGAL_URLS.speechToTextNotice,
}

interface TermsTextProps {
  continueAsEmail?: string
}

export const TermsText = ({ continueAsEmail }: TermsTextProps) => (
  <p className='font-sans text-xs leading-[1.4] text-text-secondary text-center w-full [&_a]:text-text-secondary [&_a]:underline [&_a]:decoration-skip-ink-none [&_a:hover]:text-text-primary'>
    <Trans
      i18nKey={
        continueAsEmail
          ? 'emailEntry.termsTextWithContinueAs'
          : 'emailEntry.termsText'
      }
      values={continueAsEmail ? { email: continueAsEmail } : undefined}
      components={{
        q: <q />,
        ...Object.fromEntries(
          Object.entries(links).map(([key, href]) => [
            key,
            <a
              key={key}
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              style={{ textDecoration: 'underline' }}
            />,
          ]),
        ),
      }}
    />
  </p>
)
